import { Component, ViewChild, inject, input, signal } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatDialog } from '@angular/material/dialog';
import { AddItemDialogComponent } from '../add-item-dialog/add-item-dialog.component';
import { LucideAngularModule } from 'lucide-angular';
import {
  ChevronDown,
  Search,
  List,
  Zap,
  Edit2,
  Plus,
  RefreshCcw,
} from 'lucide-angular';
import { SurveyListStore } from '../../base-classes/survey-list-controller.state';
import { SurveyList,ListType} from '@hyper-inferno/survey-elements-core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'lib-item-selector',
  imports: [
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatMenuModule,
    FormsModule,
    MatListModule,
    LucideAngularModule,
    CommonModule,
  ],
  templateUrl: './item-selector.component.html',
  styleUrl: './item-selector.component.scss',
})
export class ItemSelectorComponent {
  readonly store = inject(SurveyListStore);

  readonly dialog = inject(MatDialog);
  private route = inject(ActivatedRoute);
  selectedList: SurveyList | null = null;
  showError = false;
  readonly ChevronDownIcon = ChevronDown;
  readonly SearchIcon = Search;
  readonly ListIcon = List;
  readonly ZapIcon = Zap;
  readonly EditIcon = Edit2;
  readonly PlusIcon = Plus;
  readonly RefreshIcon = RefreshCcw;
  surveyId = signal<number | undefined>(undefined);
  listName = input<any>();
  es_entityName = input<string>();
  constructor() {
    this.route.parent?.params.subscribe((params) => {
      const id = params['id'];
      this.surveyId.set(id ? Number(id) : undefined);
    });
  }
  // 3. Action Handlers
  selectList(listId: string | undefined): void {
    this.store.setActiveList(listId);
    this.showError = false;
    // Close the menu after selection
    this.listMenuTrigger?.closeMenu();
  }
  listType=ListType
  handleNewList(type: ListType, listId?: string) {
    // Close the menu first
    this.listMenuTrigger?.closeMenu();
    const dialogRef = this.dialog.open(AddItemDialogComponent, {
      width: '900px',
      data: {
        listType: type,
        surveyId:this.surveyId(),
        selectedListId: listId || this.store.activeListId(),
        es_entityName: this.es_entityName(),
        listName: this.listName(),
      },
    });
       // Refresh data when dialog closes
       dialogRef.afterClosed().subscribe((result) => {
        if (result?.success) {
          // Refresh lists if needed
          this.store.loadLists(this.surveyId()!);
           // If a new list was created, select it
          //  if (result.listId) {
          //   this.store.setActiveList(result.listId);
          // }
        }
      });
  }

  handleCarryForward(): void {
    // Implement logic for carrying forward items
  }
  @ViewChild(MatMenuTrigger) listMenuTrigger!: MatMenuTrigger;
}
